// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}

.styles_link__g9IxC {
  cursor: pointer;
  color: #5c69f9;
}
.styles_link__g9IxC:hover {
  text-decoration: underline;
}

.styles_text-gradient-intel__Dygzj {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.styles_text-xs__YI4PO, .styles_button_xxs__KgEVi, .styles_button_xs__uJb7g {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.styles_text-sm__6AV4z, .styles_button_sm__QP8\\+4 {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.styles_text-base__99UiM {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.styles_text-lg__Ij--j {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .styles_text-lg__Ij--j {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.styles_text-xl__9rYxC {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .styles_text-xl__9rYxC {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.styles_text-leading__dwu6S {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .styles_text-leading__dwu6S {
    line-height: 1.5rem;
  }
}

.styles_button__AmGD0 {
  background-color: var(--color-primary-500);
  outline: none;
  border: none;
  border-radius: 11px;
  cursor: pointer;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #fff;
  font-weight: 400;
  transition: all 0.3s ease-in-out;
}
.styles_button_xxs__KgEVi {
  padding: 3px 7px;
}
.styles_button_xs__uJb7g {
  height: 32px;
  padding: 6px 8px;
}
.styles_button_sm__QP8\\+4 {
  height: 38px;
  padding: 9px 11px;
}
@media only screen and (max-width: 450px) {
  .styles_button_sm__QP8\\+4 {
    padding: 7px 9px;
  }
}
.styles_button_md__8ofes {
  font-size: 15px;
  padding: 10px 15px;
}
.styles_button_lg__PqpGs {
  font-size: 16px;
  padding: 12px 17px;
}
.styles_button__AmGD0:hover:not([disabled]):not(.styles_button_download__CyYkL):not(.styles_button_processing__\\+xC1F) {
  background-color: var(--color-primary-400);
}
.styles_button_secondary__2aG8x {
  transition: none;
  background-color: var(--color-secundary-500);
}
.styles_button_secondary__2aG8x:hover, .styles_button_secondary__2aG8x:active, .styles_button_secondary__2aG8x:focus {
  background: linear-gradient(var(--color-secundary-500), rgba(0, 0, 0, 0.9)) top/100% 500% !important;
}
.styles_button_inactive__k20UV {
  color: var(--color-gray-100);
  background-color: var(--color-gray-100) !important;
  border: 1px solid var(--color-gray-700);
  text-shadow: none;
}
.styles_button_white__o7S70 {
  text-shadow: none;
  background-color: #fff;
  color: var(--color-primary-500);
}
.styles_button_download__CyYkL {
  background-color: transparent;
  padding: 0;
  color: var(--color-primary-500);
}
.styles_button_download__CyYkL:hover {
  text-decoration: underline;
  background-color: transparent !important;
}
.styles_button_processing__\\+xC1F {
  cursor: default;
  pointer-events: none;
}
.styles_button__AmGD0:disabled {
  background-color: rgba(109, 105, 105, 0.2745098039);
  cursor: default;
  border: none;
}
.styles_button_outline__bnoRw {
  background-color: transparent;
  color: var(--color-primary-300);
  border: 1px solid var(--color-primary-500);
}
.styles_button_outline__bnoRw:hover, .styles_button_outline__bnoRw:active, .styles_button_outline__bnoRw:focus {
  background: linear-gradient(var(--color-primary-300), rgba(0, 0, 0, 0.9)) top/100% 500% !important;
  color: var(--color-white-500);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/components/atoms/Button/styles.module.scss","webpack://./src/assets/scss/_breakpoint.scss"],"names":[],"mappings":"AAOA;EACI,qBAAA;ACNJ;;ADQA;EACI,eAAA;EACA,cAAA;ACLJ;ADMI;EACE,0BAAA;ACJN;;ADQA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ACLJ;;ADQI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ACLR;ADOI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACLR;ACnCE;EFsCE;IAIQ,eAAA;IACA,mBAAA;ECHV;AACF;ADKI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACHR;AC7CE;EF8CE;IAIQ,eAAA;IACA,mBAAA;ECDV;AACF;ADGI;EACI,mBAAA;ACDR;ACtDE;EFsDE;IAGQ,mBAAA;ECCV;AACF;;AA1DA;EACE,0CAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AA4DF;AAzDE;EAEE,gBAAA;AA0DJ;AAxDE;EAEE,YAAA;EACA,gBAAA;AAyDJ;AAvDE;EAEE,YAAA;EACA,iBAAA;AAwDJ;ACtFE;ED2BA;IAKI,gBAAA;EA0DJ;AACF;AAxDE;EACE,eAAA;EACA,kBAAA;AA0DJ;AAxDE;EACE,eAAA;EACA,kBAAA;AA0DJ;AAtDE;EACE,0CAAA;AAwDJ;AArDE;EACE,gBAAA;EACA,4CAAA;AAuDJ;AAtDI;EAGE,oGAAA;AAsDN;AAlDE;EACE,4BAAA;EACA,kDAAA;EACA,uCAAA;EACA,iBAAA;AAoDJ;AAlDE;EACE,iBAAA;EACA,sBAAA;EACA,+BAAA;AAoDJ;AAlDE;EACE,6BAAA;EACA,UAAA;EACA,+BAAA;AAoDJ;AAnDI;EACE,0BAAA;EACA,wCAAA;AAqDN;AAlDE;EACE,eAAA;EACA,oBAAA;AAoDJ;AAhDE;EACE,mDAAA;EACA,eAAA;EACA,YAAA;AAkDJ;AAhDE;EACE,6BAAA;EACA,+BAAA;EACA,0CAAA;AAkDJ;AAjDI;EAGE,kGAAA;EAEA,6BAAA;AAgDN","sourcesContent":["@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@use \"/src/assets/scss/breakpoint\" as *;\n@use \"/src/assets/scss/theme/typography\" as *;\n.button {\n  background-color: var(--color-primary-500);\n  outline: none;\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // @include textShadow();\n  gap: 6px;\n  color: #fff;\n  font-weight: 400;\n  transition: all 0.3s ease-in-out;\n\n  // SIZES\n  &_xxs {\n    @extend .text-xs;\n    padding: 3px 7px;\n  }\n  &_xs {\n    @extend .text-xs;\n    height: 32px;\n    padding: 6px 8px;\n  }\n  &_sm {\n    @extend .text-sm;\n    height: 38px;\n    padding: 9px 11px;\n    @include mobile {\n      padding: 7px 9px;\n    }\n  }\n  &_md {\n    font-size: 15px;\n    padding: 10px 15px;\n  }\n  &_lg {\n    font-size: 16px;\n    padding: 12px 17px;\n  }\n\n  // STYLES\n  &:hover:not([disabled]):not(&_download):not(&_processing) {\n    background-color: var(--color-primary-400);\n    // background: linear-gradient(var(--color-primary-500), rgb(0 0 0/75%)) top/100% 500%;\n  }\n  &_secondary {\n    transition: none;\n    background-color: var(--color-secundary-500);\n    &:hover,\n    &:active,\n    &:focus {\n      background: linear-gradient(var(--color-secundary-500), rgb(0 0 0/90%))\n        top/100% 500% !important;\n    }\n  }\n  &_inactive {\n    color: var(--color-gray-100);\n    background-color: var(--color-gray-100) !important;\n    border: 1px solid var(--color-gray-700);\n    text-shadow: none;\n  }\n  &_white {\n    text-shadow: none;\n    background-color: #fff;\n    color: var(--color-primary-500);\n  }\n  &_download {\n    background-color: transparent;\n    padding: 0;\n    color: var(--color-primary-500);\n    &:hover {\n      text-decoration: underline;\n      background-color: transparent !important;\n    }\n  }\n  &_processing {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  // EVENTS\n  &:disabled {\n    background-color: #6d696946;\n    cursor: default;\n    border: none;\n  }\n  &_outline {\n    background-color: transparent;\n    color: var(--color-primary-300);\n    border: 1px solid var(--color-primary-500);\n    &:hover,\n    &:active,\n    &:focus {\n      background: linear-gradient(var(--color-primary-300), rgb(0 0 0/90%))\n        top/100% 500% !important;\n      color: var(--color-white-500);\n    }\n  }\n}\n","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `styles_link__g9IxC`,
	"text-gradient-intel": `styles_text-gradient-intel__Dygzj`,
	"text-xs": `styles_text-xs__YI4PO`,
	"button_xxs": `styles_button_xxs__KgEVi`,
	"button_xs": `styles_button_xs__uJb7g`,
	"text-sm": `styles_text-sm__6AV4z`,
	"button_sm": `styles_button_sm__QP8+4`,
	"text-base": `styles_text-base__99UiM`,
	"text-lg": `styles_text-lg__Ij--j`,
	"text-xl": `styles_text-xl__9rYxC`,
	"text-leading": `styles_text-leading__dwu6S`,
	"button": `styles_button__AmGD0`,
	"button_md": `styles_button_md__8ofes`,
	"button_lg": `styles_button_lg__PqpGs`,
	"button_download": `styles_button_download__CyYkL`,
	"button_processing": `styles_button_processing__+xC1F`,
	"button_secondary": `styles_button_secondary__2aG8x`,
	"button_inactive": `styles_button_inactive__k20UV`,
	"button_white": `styles_button_white__o7S70`,
	"button_outline": `styles_button_outline__bnoRw`
};
export default ___CSS_LOADER_EXPORT___;
